import { Injectable, TemplateRef } from '@angular/core';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';

import { Observable, tap } from 'rxjs';
import { LocalService } from "./local.service";
import { ToastService } from './toast.service';
import { Router } from '@angular/router';

@Injectable()
export class FormInterceptor implements HttpInterceptor {

  constructor(private localStore: LocalService, private toastService: ToastService, private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip toastService error handler
    if (request.headers.get('X-Skip-Error-Interceptor')) {
      const clonedRequest = request.clone({ headers: request.headers.delete('X-Skip-Error-Interceptor') });
      return next.handle(clonedRequest);
    }

    if (request.body instanceof FormData) {
      return next.handle(request);
    }

    const model: any = {};
    Object.keys(localStorage).forEach(key => {
      if (key.includes("interceptor")) {
        const value = this.localStore.getData(key);
        const originalKey = key.replace(/interceptor./g, '');
        model[originalKey] = isNaN(Number(value)) ? value : Number(value);
      }
    });

    const modifiedRequest = this.handleBodyIn(request, model)
    //const modifiedRequest = request;
    return next.handle(modifiedRequest).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (request.method.toLowerCase() === 'post' || request.method.toLowerCase() === 'put') {
              if (!request.url.includes('/search')) {
                if ((!request.url.includes('siep-cms/page'))) {
                  setTimeout(() => {
                    this.toastService.show({ template: 'success', classname: 'bg-success text-light', delay: 3000, message: 'Operazione effettuata con successo' });
                  }, 200);
                }
              }
            }
          }
        },
        (error) => {
          console.error(error);
          if (request.method.toLowerCase() === 'post') {
            if (request.url.includes('siep-cms/page')) {
              //this.router.navigate(['/not-found']);
            }
          }
          setTimeout(() => {
            this.toastService.show({ template: 'dangerTpl', classname: 'bg-danger text-light', delay: 5000, error: error.status || 500, message: error.error.message ? error.error.message : "Errore generico" });
          }, 200);
        }
      )
    );
  }

  showStandard(template: TemplateRef<any>) {
    this.toastService.show({ template });
  }

  handleBodyIn(req: HttpRequest<any>, model: {}) {

    const method = req.method.toLowerCase();
    let updatedReq = req.clone();

    // Funzione per aggiungere parametri della query string
    const updateRequestWithQueryParams = () => {
      updatedReq = updatedReq.clone({
        setParams: model
      });
    };

    if (method === 'post' || method === 'put') {

      updatedReq = updatedReq.clone({
        body: { ...req.body, ...model }
      });

      updateRequestWithQueryParams();

    } else if (method === 'get') {
      updateRequestWithQueryParams();
    }

    return updatedReq;

  }


}
